import { useAppSelector } from '../../../lib/store/hooks';
import { Form } from 'antd';
import { useState } from 'react';
import { useDateArrange } from '../../userManagement/hooks/table/useDateArrange';
import { useDateColumn } from '../../../features/table/helpers/useDateColumn';
import { CAMPAIGN_COLUMNS } from '../helpers/consts';
import { useCampaignArrangeRequest } from './useCampaignArrangeRequest';

type Props = {
  title: string;
  arrangedId: CAMPAIGN_COLUMNS;
  filterFromName: string;
  filterToName: string;
  headerCellProps?: any;
  columnProps?: any;
};

export function useCampaignDateColumn({
  title,
  arrangedId,
  filterFromName,
  filterToName,
  headerCellProps,
  columnProps,
}: Props) {
  const { arrangeId, sorting } = useAppSelector(({ campaigns }) => campaigns);
  const { appLang } = useAppSelector(({ auth }) => auth);

  const isActiveArrange = arrangeId === arrangedId;
  const [form] = Form.useForm();
  const [filterLabel, setFilterLabel] = useState('');

  const { getFilterLabel, formattedFromDate, formattedToDate } = useDateArrange(
    form,
    appLang,
  );

  const getFilters = () => ({
    [filterFromName]: formattedFromDate,
    [filterToName]: formattedToDate,
  });

  const { applyArranges, removeFilter } = useCampaignArrangeRequest({
    arrangedId,
    getFilterLabel,
    getFilters,
    form,
    setFilterLabel,
    isDate: true,
  });

  return useDateColumn({
    title,
    applyArranges,
    removeFilter,
    arrangedId,
    isActiveArrange,
    form,
    sortOrder: sorting.sortOrder,
    filterLabel,
    columnProps,
    toDefTime: true,
    ...headerCellProps,
  });
}
